module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Instrument.js"));
	}, "Instrument");
}